import type { Tutorial } from '@/types';

export const THANKS_TUTORIAL = [
    {
        title: 'PORADNIK<br>DARCZYŃCZYŃ I&nbsp;DARCZYŃCÓW',
        text: 'odpowiedzi na najczęściej zadawane pytania ',
        link: 'https://www.szlachetnapaczka.pl/poradnik-darczyncy/',
        icon: require('@/assets/images/infoSection/icon-book.png?as=webp&w=75')
    },
    {
        title: 'ZAPROSZENIE<br>DO ZROBIENIA PACZKI',
        text: 'materiały i inspiracje pomagające w zaangażowaniu grupy',
        link: 'https://www.szlachetnapaczka.pl/zrob-ze-mna-paczke/',
        icon: require('@/assets/images/infoSection/icon-bulb.png?as=webp&w=75')
    },
    {
        title: 'SZLACHETNA PACZKA<br>W&nbsp;GRUPIE',
        text: '10 kroków do paczki w szkole, w firmie, ze znajomymi',
        link: 'https://www.szlachetnapaczka.pl/paczka-w-paczce/',
        icon: require('@/assets/images/infoSection/icon-group.png?as=webp&w=75')
    },
    {
        title: 'MATERIAŁY<br>DO POBRANIA',
        text: 'gotowe grafiki, teksty, checklisty, arkusze kalkulacyjne,',
        link: 'https://www.szlachetnapaczka.pl/materialy-do-pobrania/',
        icon: require('@/assets/images/infoSection/icon-guide.png?as=webp&w=75')
    }
] as const satisfies Tutorial[];
